import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-events-training',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatAccordion,
    MatExpansionModule,
    MatDividerModule
  ],
  templateUrl: './events-training.page.html',
  styleUrl: './events-training.page.scss'
})
export class EventsTrainingPage implements OnInit, OnDestroy {

  current = 0;
  private intervalId: any;


  /* Auto Slide Start */

  ngOnInit() {

    this.startAutoSlide();

  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }


  startAutoSlide(): void {
    // Clear any existing interval first
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.current = (this.current + 1) % this.total;
    }, 5000);
  }

  stopAutoSlide(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  upcomingeventcards = [
     {
      title: 'Public Speaking for Financial Consultants',
      subtitle: 'View',
      image: 'assets/images/events/image015.png',
      sectionId: 'T-1',
      content: []

    },
     {
      title: 'Investment Advisory Series',
      subtitle: 'View',
      image: 'assets/images/events/image014.jpg',
      sectionId: 'T-2',
      content: []

    },
    {
      title: 'Level II - Practitioner (Referral)',
      subtitle: 'View',
      image: 'assets/images/events/image4.png',
      sectionId: 'T-3',
      content: []

    },
  ];

  pasteventcards = [
    {
      title: 'Smart Structures , Smarter Returns',
      subtitle: 'View',
      image: 'assets/images/events/image012.png',
      sectionId: 'T-1',
      content: []

    },
    {
      title: 'Sweat Therapy 2026',
      subtitle: 'View',
      image: 'assets/images/events/image009.png',
      sectionId: 'T-2',
      content: []

    },
    {
      title: 'Comprehensive Planning with Trusts in Singapore',
      subtitle: 'View',
      image: 'assets/images/events/image010.png',
      sectionId: 'T-1',
      content: []

    },
    {
      title: 'Strategic Use of Trust Structures',
      subtitle: 'View',
      image: 'assets/images/events/image011.png',
      sectionId: 'T-3',
      content: []

    },
    {
      title: 'How to Prevent Injuries that sideline you',
      subtitle: 'View',
      image: 'assets/images/events/image008.png',
      sectionId: 'T-4',
      content: []

    },
    {
      title: 'Pain-Free Days, Restful Nights',
      subtitle: 'View',
      image: 'assets/images/events/image005.png',
      sectionId: 'T-5',
      content: []
    },
    {
      title: 'Empowering Everyday Hearing Health',
      subtitle: 'View',
      image: 'assets/images/events/image004.png',
      sectionId: 'T-6',
      content: []
    },
    {
      title: 'Webinar  - Cancer Decoded',
      subtitle: 'View',
      image: 'assets/images/events/image002.png',
      sectionId: 'T-7',
      content: []
    },
    {
      title: 'Webinar  - From Polyp to Problem',
      subtitle: 'View',
      image: 'assets/images/events/image003.png',
      sectionId: 'T-8',
      content: []
    },
    {
      title: 'Clear mind, Confident you',
      subtitle: 'View',
      image: 'assets/images/events/image001.png',
      sectionId: 'T-9',
      content: []
    },
    {
      title: 'Stroke Awareness Talk + Site Visit',
      subtitle: 'View',
      image: 'assets/images/events/image1.png',
      sectionId: 'T-10',
      content: []
    },
    {
      title: 'Breast Cancer Awareness Talk',
      subtitle: 'View',
      image: 'assets/images/events/image2.png',
      sectionId: 'T-11',
      content: []

    },
    {
      title: 'Basic Health Screening – March 2026 ',
      subtitle: 'View',
      image: 'assets/images/events/image3.png',
      sectionId: 'T-12',
      content: []

    },
    {
      title: 'Balancing Income Opportunities and Risk',
      subtitle: 'View',
      image: 'assets/images/events/training1.png',
      sectionId: 'T-13',
      content: []
    },
    {
      title: 'Money Masetery Accelerator Workshop',
      subtitle: 'View',
      image: 'assets/images/events/training2.png',
      sectionId: 'T-14',
      content: []

    },
    {
      title: 'Level1-Foundation',
      subtitle: 'View',
      image: 'assets/images/events/training3.png',
      sectionId: 'T-15',
      content: []

    },
    {
      title: 'CNY Fengshui Talk 2026 and Investment Market Outlook',
      subtitle: 'View',
      image: 'assets/images/events/training4.png',
      sectionId: 'T-16',
      content: []

    },
  ];

  get total(): number {
    return this.upcomingeventcards.length;
  }


  move(direction: number): void {
    const total = this.total;
    if (total === 0) return;
    this.current = (this.current + direction + total) % total;
  }

  // Jumps directly to a given index (used by dots)
  // Also handles the card-click signature: goTo(card.sectionId, i)
  goTo(indexOrSectionId: number | string, maybeIndex?: number): void {
    if (typeof indexOrSectionId === 'number') {
      // Called from dots: goTo(i)
      this.current = indexOrSectionId;
      return;
    }

    if (typeof maybeIndex === 'number') {
      // Called from card click: goTo(card.sectionId, i)
      this.current = maybeIndex;

      const sectionId = indexOrSectionId;
      if (sectionId) {
        const el = document.getElementById(sectionId);
        el?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }


  getTo(index: number) {
    this.stopAutoSlide();
    this.current = index;
    this.startAutoSlide();
  }

  getPosition(i: number): string {
    const total = this.total;
    if (total === 0) return '';

    let diff = i - this.current;

    // wrap into the range (-total/2, total/2]
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;

    if (diff === 0) return 'pos-active';
    if (diff === 1) return 'pos-right';
    if (diff === -1) return 'pos-left';
    if (diff > 1) return 'pos-far-right';
    return 'pos-far-left';
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') this.move(-1);
    if (event.key === 'ArrowRight') this.move(1);
  }
}

